module.exports = __webpack_public_path__ + "static/img/robert-logo.67c7580.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robert-logo.png
// module id = 9P3Q
// module chunks = 1